import { AssertionQuestion } from "components/Assertions/AssertionQuestion";
import { Heading, HeadingTag } from "components/common/Heading";
import { VisibleSection } from "components/common/VisibleSection";
import { AssertionAnswers } from "domain/assertions";
import { Button, Col } from "reactstrap";
import {
  ATTESTATION_1_NO_ANSWER,
  ATTESTATION_1_YES_ANSWER,
  ATTESTATION_2_NO_ANSWER,
  ATTESTATION_2_YES_ANSWER,
  ATTESTATION_3_NO_ANSWER,
  ATTESTATION_3_YES_ANSWER,
  ATTESTATION_SCREEN_HEADER,
  ATTESTATION_SCREEN_QUESTION_1_ENTITY_TYPE_L,
  ATTESTATION_SCREEN_QUESTION_2,
  ATTESTATION_SCREEN_QUESTION_3,
} from "./Attestations.const";

export type AttestationsProps = {
  questions: AssertionAnswers;
  onChange: (answers: AssertionAnswers) => void;
  onBack: () => void;
  onReady: () => void;
  onWrongAnswer: (answers: AssertionAnswers) => void;
  disabled?: boolean;
};

export const Attestations = ({
  questions,
  onChange,
  onBack,
  onReady,
  onWrongAnswer,
  disabled,
}: AttestationsProps) => {
  const [q0, q1, q2] = questions.answers;

  const q1visible = q0.answer === q0.expected;
  const q2visible = q1.answer === q1.expected;
  const ready = q2.answer === q2.expected;

  const handleAnswer = (idx: number) => (answer: boolean) => {
    const newAnswers = questions.answers.map((answ, i) =>
      idx === i ? { ...answ, answer } : answ
    );
    if (newAnswers[idx].answer === newAnswers[idx].expected) {
      onChange({ ...questions, answers: newAnswers });
    } else {
      const clearedAnswers = newAnswers.map((a, i) =>
        i <= idx ? a : { ...a, answer: null }
      );
      onWrongAnswer({ ...questions, answers: clearedAnswers });
    }
  };

  return (
    <Col className="narrow-container">
      <div className="content-wrapper questions-screen">
        <div>
          <Heading
            tag={HeadingTag.h1}
            size={1}
            className="zb-heading1 screen-header"
            title={ATTESTATION_SCREEN_HEADER}
          />

          <div className="questions-screen-content">
            <div className="questions-block">
              <VisibleSection visible>
                <div className="question-container">
                  <AssertionQuestion
                    name={q0.type}
                    value={q0.answer}
                    disabled={disabled}
                    onChange={handleAnswer(0)}
                    confirmValue={!q0.expected}
                    noLabel={ATTESTATION_1_NO_ANSWER}
                    yesLabel={ATTESTATION_1_YES_ANSWER}
                  >
                    <p className="questions-screen-question">
                      {ATTESTATION_SCREEN_QUESTION_1_ENTITY_TYPE_L}
                    </p>
                  </AssertionQuestion>
                </div>
              </VisibleSection>
              <VisibleSection visible={q1visible}>
                <div className="question-container">
                  <AssertionQuestion
                    name={q1.type}
                    value={q1.answer}
                    disabled={disabled}
                    onChange={handleAnswer(1)}
                    confirmValue={!q1.expected}
                    noLabel={ATTESTATION_2_NO_ANSWER}
                    yesLabel={ATTESTATION_2_YES_ANSWER}
                  >
                    <p className="questions-screen-question">
                      {ATTESTATION_SCREEN_QUESTION_2}
                    </p>
                  </AssertionQuestion>
                </div>
              </VisibleSection>
              <VisibleSection visible={q2visible}>
                <div className="question-container">
                  <AssertionQuestion
                    name={q2.type}
                    value={q2.answer}
                    disabled={disabled}
                    onChange={handleAnswer(2)}
                    confirmValue={!q2.expected}
                    noLabel={ATTESTATION_3_NO_ANSWER}
                    yesLabel={ATTESTATION_3_YES_ANSWER}
                  >
                    <p className="questions-screen-question">
                      {ATTESTATION_SCREEN_QUESTION_3}
                    </p>
                  </AssertionQuestion>
                </div>
              </VisibleSection>
            </div>
          </div>
        </div>
        <div className="questions-screen-buttons">
          <Button size="lg" color="primary" block outline onClick={onBack}>
            Back
          </Button>
          <Button
            size="lg"
            color="primary"
            disabled={!ready}
            onClick={() => onReady()}
            block
          >
            Next
          </Button>
        </div>
      </div>
    </Col>
  );
};
